import { render, staticRenderFns } from "./DFormOOI.vue?vue&type=template&id=65167843&"
import script from "./DFormOOI.vue?vue&type=script&lang=js&"
export * from "./DFormOOI.vue?vue&type=script&lang=js&"
import style0 from "./DFormOOI.vue?vue&type=style&index=0&id=65167843&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports